<template>
  <v-card class="fluid-column ma-5">

    <v-card-text>

      <p class="text-headline-small">Test Reload</p>
      <p>
        <v-btn @click="timedReload.reload" color="primary" class="ma-2">trigger reload</v-btn>
      </p>
    </v-card-text>
    <v-card-text>

      <p class="text-headline-small">Test Links</p>
      <p>
        <v-btn @click="wopen" color="primary" class="ma-2">window.open</v-btn><br>
        <v-btn href="https://www.google.com" target="_blank" color="primary" class="ma-2">btn.target.blank</v-btn><br>
        <a href="https://www.google.com" target="_blank">
          <v-btn color="primary" class="ma-2">
            a.href.blank
          </v-btn>
        </a>
        <br>
        <a href="https://www.google.com" target="_new">
          <v-btn color="primary" class="ma-2">
            a.href.new
          </v-btn>
        </a>
        <br>
      </p>
    </v-card-text>
    <v-card-text>
      <p class="text-headline-small">Test Geolocation</p>
      <p>
        <v-btn @click="test_geolocation" color="primary" class="ma-2">test_geolocation</v-btn>
      </p>
    </v-card-text>
    <v-card-text>

      <p class="text-headline-small">Test Connection</p>
      <p>
        <v-btn @click="test_connection" color="primary" class="ma-2">connection</v-btn><br>
        <v-btn @click="test_connection_effective_type" color="primary" class="ma-2">effective
          type</v-btn><br>
        <v-btn @click="test_connection_type" color="primary" class="ma-2">type</v-btn><br>
      </p>
    </v-card-text>
    <v-card-text>

      <p class="text-headline-small">Test API</p>
      <p>
        <v-btn @click="secure_data_test_get" color="primary" class="ma-2">secure_data_test_get</v-btn>
        <br>
        <v-btn @click="secure_data_test_post" color="primary" class="ma-2">secure_data_test_post</v-btn>
      </p>
    </v-card-text>
    <v-card-text>
      <p class="text-headline-small">Test Toast</p>
      <p class="d-flex flex-column align-start">
        <v-btn @click="t_info_cd" color="primary" class="ma-2" prepend-icon="mdi-information"
            append-icon="mdi-timer-sand">info</v-btn>
        <v-btn @click="t_error_cd" color="error" class="ma-2" prepend-icon="mdi-close"
            append-icon="mdi-timer-sand">error</v-btn>
        <v-btn @click="t_warning" color="warning" class="ma-2" prepend-icon="mdi-alert"
            append-icon="mdi-exclamation">warning</v-btn>
        <v-btn @click="t_success" color="success" class="ma-2" prepend-icon="mdi-check"
            append-icon="mdi-exclamation">success</v-btn>
        <v-btn @click="t_success_cd" color="success" class="ma-2" prepend-icon="mdi-check"
            append-icon="mdi-timer-sand">success</v-btn>
      </p>
    </v-card-text>
    <v-card-text>
      <p class="text-headline-small">Test Error</p>
      <p class="d-flex flex-column align-start">
        <v-btn @click="generateError" color="error" class="ma-2" prepend-icon="mdi-information">generate error</v-btn>
      </p>
    </v-card-text>

    <v-card-text>
      <p class="text-headline-small">Test Sounds</p>
      <p class="d-flex flex-column align-start">
        <v-btn @click="testSound('info')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">info</v-btn>
        <v-btn @click="testSound('error')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">error</v-btn>
        <v-btn @click="testSound('warning')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">warning</v-btn>
        <v-btn @click="testSound('success')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">success</v-btn>
        <v-btn @click="testSound('click')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">click</v-btn>
        <v-btn @click="testSound('update')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">update</v-btn>
        <v-btn @click="testSound('startup')" color="primary" class="ma-2" prepend-icon="mdi-volume-high">startup</v-btn>
      </p>
    </v-card-text>

  </v-card>
</template>

<script setup>

import { useApi, } from "@/service/api";
import { useToastsStore } from "@/store/toasts";
import { useTimedReload } from "@/service/timedReload"
// import { v4 as uuidv4 } from 'uuid'
import { useSound } from "@/service/sound"


const timedReload = useTimedReload()
const toastsStore = useToastsStore();
const api = useApi()
const soundService = useSound()



const getNetworkData = () => {
  const networkData = {}
  for (const key in navigator.connection) {
    if (typeof navigator.connection[key] !== "function") {
      networkData[key] = navigator.connection[key]
    }
  }
  return networkData
}

const wopen = async () => {
  window.open("https://www.google.com", "_blank")

  window.open("https://www.w3schools.com","_blank","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=400, height=400")

}

const test_connection = () => {
  console.log(navigator.connection)
  toastsStore.toast({
    duration: 10000,
    text: "connection:\n " + JSON.stringify(getNetworkData(), null, 4),
    type: 'info',
    title: 'GET',
  })
}
const test_connection_effective_type = () => {
  console.log(navigator.connection.effective_type)
  toastsStore.toast({
    duration: 10000,
    text: "connection:\n " + JSON.stringify(getNetworkData().effectiveType, null, 4),
    type: 'info',
    title: 'GET',
  })
}
const test_connection_type = () => {
  console.log(navigator.connection.type)
  toastsStore.toast({
    duration: 10000,
    text: "connection:\n " + JSON.stringify(getNetworkData().type, null, 4),
    type: 'info',
    title: 'GET',
  })
}

const test_geolocation = async () => {
  let pos = undefined

  await navigator.geolocation.getCurrentPosition((newpos) => pos = newpos, (err) => console.error(err))

  console.log(pos)

  toastsStore.toast({
    duration: 10000,
    text: "location:\n " + JSON.stringify(pos, null, 4),
    type: 'info',
    title: 'GET',
  })
}

const secure_data_test_get = async () => {
  console.log("secure_data_test_get fired")
  const result = await api.tracker.sdtg()
  console.log(result)
  toastsStore.toast({
    duration: 10000,
    text: JSON.stringify(result.data, null, 4),
    type: 'info',
    title: 'GET',
  })
}
const secure_data_test_post = async () => {
  console.log("secure_data_test_post fired")
  const data = {
    "test": "test"
  }
  const result = await api.tracker.sdtp(data)
  console.log(result)
  toastsStore.toast({
    duration: 10000,
    text: JSON.stringify(result.data, null, 4),
    type: 'info',
    title: 'POST',
  })
}


const t_info_cd = () => {
  toastsStore.toast({
    duration: 10000,
    text: 'informations about this messy message, too long, perhaps it will be cutted?',
    type: 'info',
    title: 'title',
    showUICountdown: true,
  })
}
const t_error_cd = () => {
  toastsStore.toast({
    duration: 10000,
    text: 'message',
    type: 'error',
    title: 'title, very very very long title, will it fit?',
    showUICountdown: true,
  })
}
const t_warning = () => {
  toastsStore.toast({
    duration: 10000,
    text: 'message',
    type: 'warning',
    title: 'title',
    showUICountdown: false,
  })
}
const t_success = () => {
  toastsStore.toast({
    duration: 3000,
    text: 'message',
    type: 'success',
    title: 'title',
    showUICountdown: false,
  })
}
const t_success_cd = () => {
  toastsStore.toast({
    duration: 3000,
    text: 'message',
    type: 'success',
    title: 'title',
    showUICountdown: true,
  })
}



const generateError = async () => {
  const error = "test error"

  toastsStore.toast({
    duration: 5000,
    text: 'generato errore',
    type: 'error',
    title: 'Errore!!!',
  })

  throw new Error(error)
}

const testSound =  (soundToPlay) => {
  soundService.play(soundToPlay)
  
}


</script>

<style scoped>
ul {
  padding-left: 20px;
}
</style>
